import React from 'react';
import Navbar from '../../Navbar';
import Hero from '../../Hero';
import ComparisonTable from '../../ComparisonTable';
import Pricing from '../../Pricing';
import McpSection from '../../McpSection';
import Footer from '../../Footer';

const MainPage: React.FC = () => {
  return (
    <div className="bg-slate-900 min-h-screen text-white font-sans antialiased selection:bg-sky-500/30 selection:text-sky-200">
      <Navbar />
      <main>
        <Hero />
        <ComparisonTable />
        <Pricing />
        <McpSection />
      </main>
      <Footer />
    </div>
  );
};

export default MainPage;